<template>
    <main role="main" class="cp-v2">
        <portal to="ariane">
            <div class="tbv2-page-title">
                <router-link to="/post/create/forms" class="tbv2-crumb">{{ $t('menu.tickets.create') || 'Créer un ticket' }}</router-link>
                <span class="tbv2-sep">/</span>
                <span class="tbv2-current">{{ $t('wizard.newForm') }}</span>
            </div>
        </portal>

        <div v-if="loading" class="cp-loading">
            <i class="fal fa-spinner-third fa-spin"></i>
        </div>

        <CustomWizard v-else :form-id="formId" :is-backoffice="true" />
    </main>
</template>

<script>
/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
import CustomWizard from '@/components/Wizard/CustomWizard.vue'
import { mapActions } from 'vuex'

export default {
    name: 'CreatePost',
    components: { CustomWizard },
    data() {
        return {
            loading: true
        }
    },
    computed: {
        formId() {
            return this.$route.params.formId
        }
    },
    created() {
        this.getInitialForm()
    },
    beforeDestroy() {
        this.$store.commit('post/setPost', null)
        this.$store.dispatch('map/reset')
    },
    methods: {
        ...mapActions('form', ['getPublicForm']),
        getInitialForm() {
            this.getPublicForm(this.formId)
                .then(() => {
                    this.$store.commit('post/setPost', { attributes: {} })
                })
                .catch((error) => {
                    this.$store.dispatch('dispatchError', error)
                })
                .finally(() => {
                    this.loading = false
                })
        }
    }
}
</script>

<style scoped>
.cp-v2 {
    width: 100%;
    padding: 24px 32px 48px;
    font-family: var(--v2-font-sans);
    color: var(--v2-text-2);
}

.tbv2-page-title {
    font-size: 0.95rem;
    font-weight: var(--v2-font-weight-semibold);
    color: var(--v2-text-1);
    letter-spacing: -0.005em;
    display: inline-flex;
    align-items: center;
    gap: 6px;
}

.tbv2-crumb {
    color: var(--v2-text-3);
    text-decoration: none !important;
    font-weight: var(--v2-font-weight-medium);
    transition: color var(--v2-transition-fast);
}

.tbv2-crumb:hover {
    color: var(--v2-primary);
}

.tbv2-sep {
    color: var(--v2-text-4);
}

.tbv2-current {
    color: var(--v2-text-1);
}

.cp-loading {
    display: flex;
    justify-content: center;
    padding: var(--v2-space-6);
    color: var(--v2-text-3);
    font-size: 1.5rem;
}

@media (max-width: 900px) {
    .cp-v2 {
        padding: 16px 18px 32px;
    }
}
</style>
